<template>
    <div class="billing-sidebar" :style="width ? {width: width + 'px'} : null">
        <div class="billing-sidebar-plan" @click="$emit('navigate', 'packages')">
            <div class="billing-sidebar-plan-header">
                <span class="billing-sidebar-plan-name">{{ primaryPlanName }}</span>
                <span class="billing-sidebar-plan-badge">{{ $t('common.billing.active') }}</span>
            </div>
            <div v-if="bs.activePlans.value.length > 1" class="billing-sidebar-plan-tags">
                <span v-for="plan in bs.activePlans.value" :key="plan.id" class="billing-sidebar-plan-tag" :style="{borderColor: plan.color}">{{ plan.name }}</span>
            </div>
            <div class="billing-sidebar-plan-expiry">{{ bs.formatDate(bs.state.planExpiryDate) }} {{ $t('common.billing.renews') }}</div>
        </div>

        <div class="billing-sidebar-section">
            <div class="billing-sidebar-section-title">{{ $t('common.billing.general') }}</div>
            <div :class="['billing-sidebar-item', {'billing-sidebar-item--active': bs.state.activeSection === 'packages'}]"
                 @click="$emit('navigate', 'packages')">
                <span class="billing-sidebar-item-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 3H8l-2 4h12z"/></svg>
                </span>
                <span class="billing-sidebar-item-label">{{ $t('common.billing.packages') }}</span>
            </div>
            <div :class="['billing-sidebar-item', {'billing-sidebar-item--active': bs.state.activeSection === 'modules'}]"
                 @click="$emit('navigate', 'modules')">
                <span class="billing-sidebar-item-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 17.5h7"/><path d="M17.5 14v7"/></svg>
                </span>
                <span class="billing-sidebar-item-label">{{ $t('common.billing.modules') }}</span>
            </div>
        </div>

        <div class="billing-sidebar-divider"></div>

        <div class="billing-sidebar-section">
            <div class="billing-sidebar-section-title">{{ $t('common.billing.myAccount') }}</div>
            <div :class="['billing-sidebar-item', {'billing-sidebar-item--active': bs.state.activeSection === 'orders' || bs.state.activeSection === 'orderDetail'}]"
                 @click="$emit('navigate', 'orders')">
                <span class="billing-sidebar-item-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                </span>
                <span class="billing-sidebar-item-label">{{ $t('common.billing.orders') }}</span>
                <span class="billing-sidebar-item-badge">{{ bs.ORDERS.length }}</span>
            </div>
            <div :class="['billing-sidebar-item', {'billing-sidebar-item--active': bs.state.activeSection === 'wallet'}]"
                 @click="$emit('navigate', 'wallet')">
                <span class="billing-sidebar-item-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg>
                </span>
                <span class="billing-sidebar-item-label">{{ $t('common.billing.wallet') }}</span>
                <span class="billing-sidebar-item-badge">{{ bs.formatPrice(bs.state.walletBalance) }}&#8378;</span>
            </div>
            <div :class="['billing-sidebar-item', {'billing-sidebar-item--active': bs.state.activeSection === 'cards'}]"
                 @click="$emit('navigate', 'cards')">
                <span class="billing-sidebar-item-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                </span>
                <span class="billing-sidebar-item-label">{{ $t('common.billing.cards') }}</span>
            </div>
        </div>

        <div class="billing-divider-resize" :style="{right: '-3px'}" @mousedown.prevent="$emit('divider-start', $event)"></div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingSidebar',
    props: {
        width: { type: Number, default: null },
    },
    emits: ['navigate', 'divider-start'],
    computed: {
        bs() {
            return billingService
        },
        primaryPlanName() {
            const plans = billingService.activePlans.value
            if (!plans.length) return ''
            if (plans.length === 1) return plans[0].name + ' Plan'
            return plans.length + ' Plan'
        },
    },
}
</script>
